import { createAction } from '@reduxjs/toolkit';

const FETCHING_GRADE_LIST = 'FETCHING_GRADE_LIST';
const FETCHING_GRADE_LIST_SUCCESS = 'FETCHING_GRADE_LIST_SUCCESS';
const FETCHING_GRADE_LIST_FAILURE = 'FETCHING_GRADE_LIST_FAILURE';
const CREATE_GRADE = 'CREATE_GRADE';
const GET_GRADE_DETAIL = 'GET_GRADE_DETAIL';
const UPDATE_GRADE = 'UPDATE_GRADE';
const CLEAR_GRADE = 'CLEAR_GRADE';
const FETCHING_GRADE_MODULE_LIST = 'FETCHING_GRADE_MODULE_LIST';
const ADD_GRADE_MODULE = 'ADD_GRADE_MODULE';
const REMOVE_GRADE_MODULE = 'REMOVE_GRADE_MODULE';
const FETCH_TOTAL_MODULE_LIST = 'FETCH_TOTAL_MODULE_LIST';
export interface gradeModuleListSuccessPayload {
    id?: number | string;
    name?: string;
    description?: string;
    created_date?: string;
    updated_date?: string;
    grade?: number;
    status?: number | null;
}

export interface gradeListSuccessPayload {
    id?: number | string;
    name: string;
    en_name?: string;
    code: string;
    level_code: string;
    status: 0 | 1;
    created_date: string;
    updated_date: string;
}

type gradeDataDetailType = Omit<
    gradeListSuccessPayload,
    'id' | 'status' | 'created_date' | 'updated_date'
>;

export const fetchingGradeList = createAction(FETCHING_GRADE_LIST, (filters: any) => ({
    payload: filters,
}));
export const fetchingGradeListSuccess = createAction<
    gradeListSuccessPayload[]
>(FETCHING_GRADE_LIST_SUCCESS);
export const fetchingGradeListFailure = createAction(
    FETCHING_GRADE_LIST_FAILURE,
);
export const createGrade = createAction<gradeDataDetailType>(CREATE_GRADE);

export const getGradeDetail = createAction(
    GET_GRADE_DETAIL,
    (id: string) => ({
        payload: { id: id },
    }),
);
export const clearGrade = createAction(CLEAR_GRADE);

export const updateGrade = createAction<any>(
    UPDATE_GRADE,
    (data: gradeDataDetailType, id: string) => ({
        payload: { data: data, id: id },
    }),
);

export const fetchingGradeModuleList = createAction(FETCHING_GRADE_MODULE_LIST, (filters: any) => ({
    payload: filters,
}));

export const addGradeModule = createAction(ADD_GRADE_MODULE, (data: any) => ({
    payload: data,
}));

export const removeGradeModule = createAction(REMOVE_GRADE_MODULE, (data: any) => ({
    payload: data,
}));

export const fetchTotalModuleList = createAction(FETCH_TOTAL_MODULE_LIST, (filters: any) => ({
    payload: { filters },
  }))